'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.initializeFwwRepository = initializeFwwRepository;
exports.waitUntilFwwRepositoryIsInitialized = waitUntilFwwRepositoryIsInitialized;
exports.getFilterOptions = getFilterOptions;
exports.storeTimeSeriesInCache = storeTimeSeriesInCache;
exports.getTimeSeries = getTimeSeries;
exports.fetchFundInformation = fetchFundInformation;
exports.searchFunds = searchFunds;
exports.findFondsTypeAndCategoryForFocusAssetId = findFondsTypeAndCategoryForFocusAssetId;

var _browserJsonp = require('browser-jsonp');

var _browserJsonp2 = _interopRequireDefault(_browserJsonp);

var _cache = require('./cache');

var _validation = require('./validation');

var _arrayUtility = require('./array-utility');

var _log = require('./log');

var log = _interopRequireWildcard(_log);

var _objectUtility = require('@nimius/object-utility');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The base query settings used for FWW authentication.
 *
 * @type {Object}
 * @property {string} optionsEndPoint
 * @property {string} timeSeriesEndPoint
 * @property {string} searchEndPoint
 * @property {Object} queryParameters
 */
var configuration = null;

/**
 * A promise that is resolved, once the configuration exists.
 * @type {Promise}
 */
var _resolveConfigurationPromise = void 0;
var configurationPromise = new _promise2.default(function (resolve) {
    return _resolveConfigurationPromise = resolve;
});

/**
 * Initializes the FWW repository.
 * This has to be executed in the main app in order to enable the repository.
 * @param {{}} config
 */
function initializeFwwRepository(config) {
    configuration = config;
    _resolveConfigurationPromise(config);
}

function waitUntilFwwRepositoryIsInitialized() {
    return configurationPromise;
}

/**
 * Fetches the fund options from the API (or cache).
 */
function getFilterOptions() {
    var lifetime = 1000 * 60 * 60 * 24; // 24 hours

    return waitUntilFwwRepositoryIsInitialized().then(function () {
        return jsonpFwwRequest(configuration.optionsEndPoint, {}, {}, lifetime);
    }).then(function (data) {
        (0, _validation.validate)(data, require('../schema/filter-options-response.schema.json'));
        return data;
    }, function (e) {
        log.error('fww-repository', 'getFilterOptions', e);
        throw e;
    }).then(function (data) {

        // Sort issuers and map them into an array of object
        // that contain a `key` and `value` attribute.
        data.issuer = (0, _objectUtility.sortObject)((0, _objectUtility.cloneObject)(data.issuer), function (_ref, _ref2) {
            var _ref4 = (0, _slicedToArray3.default)(_ref, 2),
                valueA = _ref4[1];

            var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
                valueB = _ref3[1];

            valueA = ('' + valueA).toLowerCase();
            valueB = ('' + valueB).toLowerCase();

            if (valueA < valueB) return -1;
            if (valueB < valueA) return 1;
            return 0;
        }, true).map(function (_ref5) {
            var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
                key = _ref6[0],
                value = _ref6[1];

            return { key: key, value: value };
        });

        return data;
    });
}

/**
 * Storesthe given timeseries in the cache.
 * @param isin
 * @param timeSeries
 * @param lifetime
 */
function storeTimeSeriesInCache(isin, timeSeries) {
    var lifetime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000 * 60 * 60;

    (0, _cache.set)('timeseries__' + isin, timeSeries, lifetime);
}

/**
 * Fetches time series for the given isins.
 * @param isins
 * @param options
 */
function getTimeSeries(isins) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var lifetime = 1000 * 60 * 60; // 1 Hour

    var timeSeries = {};
    var isinsToFetch = (0, _objectUtility.cloneObject)(isins);

    return waitUntilFwwRepositoryIsInitialized().then(function () {
        // Check, which isins are already in the cache
        // If a isins is already in the cache, then it does not have to be refetched.
        var promises = isins.map(function (isin) {
            return (0, _cache.get)('timeseries__' + isin);
        });
        return _promise2.default.all(promises).then(function (timeSeriesArrayFromCache) {
            timeSeriesArrayFromCache.forEach(function (ts, index) {
                var isin = isins[index];
                if (ts) {
                    var _index = isinsToFetch.indexOf(isin);
                    isinsToFetch.splice(_index, 1);
                    timeSeries[isin] = ts;
                }
            });
        });
    }).then(function () {
        // Refetch the items, that need to be refetched.
        var promises = (0, _arrayUtility.chunkArray)(isinsToFetch, 4).map(function (isins) {
            options.IDS = isins;
            return jsonpFwwRequest(configuration.timeSeriesEndPoint, options).then(function (results) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var element = _step.value;

                        storeTimeSeriesInCache(element.meta.id, element, lifetime);
                        timeSeries[element.meta.id] = element;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }, function (e) {
            log.error('fww-repository', 'getTimeSeries', e);
            throw e;
        });
        return _promise2.default.all(promises);
    }).then(function () {
        return timeSeries;
    });
}

/**
 * Gets information about a specific fund - either from the cache or from the API.
 * @param isin
 */
function fetchFundInformation(isin) {
    log.debug('fetchFundInformation', isin);

    return (0, _cache.get)('fund__' + isin).then(function (fund) {
        if (!fund) {
            log.debug('fetchFundInformation', isin, 'not in cache, catching from query');

            return searchFunds({ query: isin }).then(function (data) {
                return data.results[isin];
            }, function (e) {
                return log.error(e);
            });
        }

        return fund;
    }, function (e) {
        log.error('fww-repository', 'fetchFundInformation', e);
        throw e;
    });
}

/**
 * Searches the funds API.
 * @param query
 * @param columnMap
 * @returns {Promise.<TResult>}
 */
function searchFunds() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var columnMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var lifetime = 1000 * 60 * 5; // 5 Minutes
    columnMap = columnMap || {
        currency: 'FUND_CURRENCY',
        issuer: 'ISSUER',
        focusAsset: 'FOCUS_ASSET',
        focusCurrency: 'FOCUS_CURRENCY',
        focusRegion: 'FOCUS_REGION',
        isin: 'NAME_WKN_ISIN',
        limit: 'LIMIT',
        offset: 'OFFSET',
        orderBy: 'ORDER_BY',
        orderByDesc: 'ORDER_DESC',
        query: 'NAME_WKN_ISIN',
        fwwFundStars: 'FWW_FUNDSTARS',
        dividendsPayout: 'DIVIDENDS_PAYOUT',
        srri: 'RISK_LEVEL_SRRI',
        minimumPerformance1Week: 'PERF_EUR_1W',
        minimumPerformance1Month: 'PERF_EUR_1M',
        minimumPerformance1Year: 'PERF_EUR_1Y',
        minimumPerformance3Years: 'PERF_EUR_3Y',
        minimumPerformance5Years: 'PERF_EUR_5Y',
        minimumPerformanceSinceInception: 'PERF_EUR_SI',
        sharpeRatio1year: 'SHARPE_RATIO_1Y',
        sharpeRatio3years: 'SHARPE_RATIO_3Y',
        sharpeRatio5years: 'SHARPE_RATIO_5Y',
        maximumDrawdownSinceInception: 'MAX_DRAWDOWN',
        minimumAge: 'MIN_AGE',
        maximumVolatility3Years: 'VOLATILITY_3Y',
        ongoingCharges: 'ONGOING_CHARGES',

        /**
         * The `savingsplan` parameter can be used in order
         * to pass an array (or a single string) of banks where the
         * client has the option to create a savings plan.
         *
         * The following banks exist:
         * - `aab`
         * - `comdirect`
         * - `dws`
         * - `ebase`
         * - `ffb`
         * - `fodb`
         * - `dab`
         *
         * @param savingsPlan
         * @param parameters
         */
        savingsPlan: function savingsPlan(_savingsPlan, parameters) {
            if (typeof _savingsPlan === 'string') {
                _savingsPlan = [_savingsPlan];
            } else if (!_savingsPlan) {
                return parameters;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(_savingsPlan), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var bank = _step2.value;

                    switch (bank) {
                        case 'aab':
                            parameters['SAVINGSPLAN_AAB'] = 1;
                            break;
                        case 'comdirect':
                            parameters['SAVINGSPLAN_COMDIRECT'] = 1;
                            break;
                        case 'dws':
                            parameters['SAVINGSPLAN_DWS'] = 1;
                            break;
                        case 'ebase':
                            parameters['SAVINGSPLAN_EBASE'] = 1;
                            break;
                        case 'ffb':
                            parameters['SAVINGSPLAN_FFB'] = 1;
                            break;
                        case 'fodb':
                            parameters['SAVINGSPLAN_FODB'] = 1;
                            break;
                        case 'dab':
                            parameters['SAVINGSPLAN_DABBNPPARIBAS'] = 1;
                            break;
                        default:
                            console.error('Filter \'capitalPerformance\': Bank ' + bank + ' is unknown');
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return parameters;
        },


        /**
         * The `capitalPerformance` parameter can be used in order
         * to pass an array (or a single string) of banks where the
         * client has the option for capital performance savings plans
         * (Vermögenswirksame Leistungen).
         *
         * The following banks exist:
         * - `aab`
         * - `comdirect`
         * - `dws`
         * - `ebase`
         * - `ffb`
         * - `fodb`
         * - `dab`
         *
         * @param performance
         * @param parameters
         */
        capitalPerformance: function capitalPerformance(performance, parameters) {
            if (typeof performance === 'string') {
                performance = [performance];
            } else if (!performance) {
                return parameters;
            }

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(performance), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var bank = _step3.value;

                    switch (bank) {
                        case 'aab':
                            parameters['VL_AAB'] = 1;
                            break;
                        case 'comdirect':
                            parameters['VL_COMDIRECT'] = 1;
                            break;
                        case 'dws':
                            parameters['VL_DWS'] = 1;
                            break;
                        case 'ebase':
                            parameters['VL_EBASE'] = 1;
                            break;
                        case 'ffb':
                            parameters['VL_FFB'] = 1;
                            break;
                        case 'fodb':
                            parameters['VL_FODB'] = 1;
                            break;
                        case 'dab':
                            parameters['VL_DABBNPPARIBAS'] = 1;
                            break;
                        default:
                            console.error('Filter \'capitalPerformance\': Bank ' + bank + ' is unknown');
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return parameters;
        },


        /**
         * The `fullDiscount` parameter can be used in order
         * to pass an array (or a single string) of banks where the
         * client has 100% discount.
         *
         * The following banks exist:
         * - `aab`
         * - `comdirect`
         * - `dws`
         * - `ebase`
         * - `ffb`
         * - `fodb`
         * - `dab`
         *
         * @param fullDiscount
         * @param parameters
         */
        fullDiscount: function fullDiscount(_fullDiscount, parameters) {
            if (typeof _fullDiscount === 'string') {
                _fullDiscount = [_fullDiscount];
            } else if (!_fullDiscount) {
                return parameters;
            }

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(_fullDiscount), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var bank = _step4.value;

                    switch (bank) {
                        case 'aab':
                            parameters['DISCOUNT_AAB'] = 100;
                            break;
                        case 'comdirect':
                            parameters['DISCOUNT_COMDIRECT'] = 100;
                            break;
                        case 'dws':
                            parameters['DISCOUNT_DWS'] = 100;
                            break;
                        case 'ebase':
                            parameters['DISCOUNT_EBASE'] = 100;
                            break;
                        case 'ffb':
                            parameters['DISCOUNT_FFB'] = 100;
                            break;
                        case 'fodb':
                            parameters['DISCOUNT_FODB'] = 100;
                            break;
                        case 'dab':
                            parameters['DISCOUNT_DABBNPPARIBAS'] = 100;
                            break;
                        default:
                            console.error('Filter \'fullDiscount\': Bank ' + bank + ' is unknown');
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return parameters;
        },


        /**
         * The `etf` parameter can have multiple values:
         * - `only`: Displays only ETF funds
         * - `exclude`: Displays only non-ETF funds
         *
         * Every value other than the ones listed above (e.g. empty
         * strings or `all` will be ignored - thus displaying both,
         * non-ETF and ETF funds.
         *
         * Though not enforced - for readability purposes using the value
         * `all` to fetch non-ETF and ETF funds in a mixed list is recommended.
         *
         * @param etf
         * @param parameters
         */
        etf: function etf(_etf, parameters) {
            parameters.IS_ETF = _etf === 'only' ? '1' : '0';
            parameters.IS_NOT_ETF = _etf === 'exclude' ? '1' : '0';
            delete parameters['etf'];
            return parameters;
        },


        /*
         * Faux attribute that set the minimum discount when a bank is in the array.
         * These attributes have been added as a workaround to filter for banks directly.
         * If in the future the API allows for direct filtering, then this mapping
         * method can be removed.
         */
        banks: function banks(_banks, parameters) {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = (0, _getIterator3.default)(_banks), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var bank = _step5.value;

                    if (!bank) {
                        continue;
                    }

                    switch (bank.toLowerCase()) {

                        case 'aab':
                            parameters['DISCOUNT_AAB'] = 0.01;
                            break;

                        case 'comdirect':
                            parameters['DISCOUNT_COMDIRECT'] = 0.01;
                            break;

                        case 'dws':
                            parameters['DISCOUNT_DWS'] = 0.01;
                            break;

                        case 'ebase':
                            parameters['DISCOUNT_EBASE'] = 0.01;
                            break;

                        case 'ffb':
                            parameters['DISCOUNT_FFB'] = 0.01;
                            break;

                        case 'fodb':
                            parameters['DISCOUNT_FODB'] = 0.01;
                            break;

                        case 'dab':
                            parameters['DISCOUNT_DABBNPPARIBAS'] = 0.01;
                            break;

                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            delete parameters['banks'];
            return parameters;
        }
    };

    return jsonpFwwRequest(configuration.searchEndPoint, query, columnMap, lifetime).then(function (data) {
        data.results = data.results || {};
        (0, _validation.validate)(data, require('../schema/search-response.schema.json'));
        return data;
    }).then(function (data) {
        var lifetime = 1000 * 60 * 60 * 3; // 3 hours
        (0, _keys2.default)(data.results).forEach(function (isin) {
            (0, _cache.set)('fund__' + isin, data.results[isin], lifetime);
        });
        return data;
    }, function (e) {
        log.error('fww-repository', 'searchFunds', e);
        throw e;
    });
}

/**
 * Executes a JSONP request to the given API Endpoint with the given
 * parameters.
 *
 * Default / authentication parameters do not have to be specified
 * as they will be added automatically.
 *
 * @param {string} url
 * @param {Object} [parameters]
 * @param {Object} columnMap
 * @param {number} cacheLifetime
 * @param {string} cachePrefix
 * @returns {Promise}
 */
function jsonpFwwRequest(url) {
    var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var columnMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var cacheLifetime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var cachePrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'fww-repository';

    var cacheKey = cachePrefix + '__' + url + '__' + (0, _stringify2.default)(parameters);
    parameters = extendQueryParameters(parameters, columnMap);

    return (0, _cache.cache)(cacheKey, cacheLifetime, function () {
        return new _promise2.default(function (resolve, reject) {

            log.info('API Request', url, parameters);
            (0, _browserJsonp2.default)({
                url: url,
                data: parameters,
                success: function success(r) {
                    if (r.error) {
                        console.error(r);
                        reject(r);
                        return;
                    }

                    resolve(r.data);
                },
                error: function error(e) {
                    return reject(e);
                }
            });
        });
    }).then(function (response) {
        return response;
    }, function (e) {
        log.error('fww-repository', 'jsonpFwwRequest', e);

        if (e.error && e.errorCode === 403 && e.errorMessage === 'Forbidden [Timestamp is not within bounds.]') {
            log.error('fww-repository', 'jsonpFwwRequest', 'API Tokens timed out');
            if (configuration.onTokenTimeout) {
                configuration.onTokenTimeout(e);
            }
        }

        throw e;
    });
}

/**
 * Adds the default query parameters to the given parameter array.
 * @param parameters
 * @returns {*}
 */
function extendQueryParameters() {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var columnMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    parameters = JSON.parse((0, _stringify2.default)(parameters));

    if (!configuration.queryParameters) {
        throw new Error('FWW Repository has not been initialized correctly. Please call the `initializeFwwRepository()` method before using a repository method.');
    }

    // Apply base query
    (0, _keys2.default)(configuration.queryParameters).forEach(function (key) {
        return parameters[key] = configuration.queryParameters[key];
    });

    // Converts the given value to a API format:
    // arrays are comma separated and true/false is represented by
    // 1 and 0.
    var convertToApiFormat = function convertToApiFormat(value) {

        if (value instanceof Array) {
            return value.join(',');
        }

        if (typeof value === 'boolean') {
            return value ? 1 : 0;
        }

        return value;
    };

    // Apply column map
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
        for (var _iterator6 = (0, _getIterator3.default)((0, _keys2.default)(columnMap)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var key = _step6.value;

            var map = columnMap[key];
            var value = parameters[key];

            if (value === undefined || value === null) {
                delete parameters[key];
                continue;
            }

            if (typeof map === 'function') {
                parameters = map(value, parameters) || parameters;
            } else {
                parameters[map] = convertToApiFormat(value);
                delete parameters[key];
            }
        }
    } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
            }
        } finally {
            if (_didIteratorError6) {
                throw _iteratorError6;
            }
        }
    }

    return parameters;
}

/**
 * Finds the correct fondsType (first level) and fondsCategory (second level)
 * for a given focusAssetId.
 *
 * This method is necessarry, because there are more focusAssets than we display, so
 * a focusAssetId, that is specified in the URL might be to specific.
 *
 * In that case, a deep search must be performed to find the correct parent categories
 * in order to have a correct / matching filter.
 *
 * The returned value will always be an Object.
 * - If no matching type and category is found, then an empty Object is returned
 * - If a matching type is found, then the key `fondsType` will be specified
 * - If a matching category is found, then the key `fondsCategory` will be specified
 *
 * @param focusAssetId
 * @param focusAssets
 * @returns {*}
 */
function findFondsTypeAndCategoryForFocusAssetId(focusAssetId, focusAssets) {
    /**
     * Queue that is used for the deep search.
     * See comment at the end of this method to find a detailed description
     * of how this works and why we need it.
     * @type {Array}
     */
    var queue = [];

    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
        for (var _iterator7 = (0, _getIterator3.default)((0, _keys2.default)(focusAssets)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var fundsType = _step7.value;


            // Return, if the focus asset is a type.
            if (fundsType === focusAssetId) {
                return { fundsType: fundsType };
            }

            // No need to dig deeper, if there are no subitems.
            if (!focusAssets[fundsType].items) {
                continue;
            }

            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = (0, _getIterator3.default)((0, _keys2.default)(focusAssets[fundsType].items)), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var fundsCategory = _step9.value;


                    // Return, if the focus asset is a category.
                    if (fundsCategory === focusAssetId) {
                        return { fundsType: fundsType, fundsCategory: fundsCategory };
                    }

                    // Push current category object to the queue,
                    // in case we need to perform a deep search.
                    queue.push({
                        asset: focusAssets[fundsType].items[fundsCategory],
                        fundsType: fundsType,
                        fundsCategory: fundsCategory
                    });
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }
        }

        /*
         * If the focus asset, that is searched for is neither a type nor a category,
         * then a deep search is performed.
         *
         * This will return the type and category that match the given focus asset id
         * the closest / are its parents.
         *
         * This deep search is implemented using a queu, that is pushed to and popped from.
         *
         * Each queue item is an object of the focus asset object that is to be searched and
         * the context in form of `fondsType` and `fondsCategory`.
         */
    } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
            }
        } finally {
            if (_didIteratorError7) {
                throw _iteratorError7;
            }
        }
    }

    while (queue.length > 0) {

        // Shift is equivalent to Array#pop, but takes the first item
        var element = queue.shift();

        // Skip, if there are no subitems.
        if (!element.asset.items) {
            continue;
        }

        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
            for (var _iterator8 = (0, _getIterator3.default)((0, _keys2.default)(element.asset.items)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var key = _step8.value;


                // Return, if the child matches.
                if (key === focusAssetId) {
                    return {
                        fundsType: element.fundsType,
                        fundsCategory: element.fundsCategory
                    };
                }

                // Push the child to the queue.
                queue.push({
                    asset: element.asset.items[key],
                    fundsType: element.fundsType,
                    fundsCategory: element.fundsCategory
                });
            }
        } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                }
            } finally {
                if (_didIteratorError8) {
                    throw _iteratorError8;
                }
            }
        }
    }

    return {};
}